import { Module } from 'wrapper6'
import Swiper from 'swiper/bundle'

const $ = jQuery

export default class CoverSlider extends Module {
  ready (app) {
    const sliderWrappers = document.querySelectorAll('.mtt-cover-slider')

    if (sliderWrappers.length) {
      for (let i = 0; i < sliderWrappers.length; i++) {
        const wrapper = sliderWrappers[i]

        const slider = new Slider(wrapper)
      }
    }
  }
}

class Slider {
  constructor (wrapper) {
    this.wrapper = wrapper

    this.addSlider()
  }

  addSlider () {
    const swiper = new Swiper(this.wrapper.querySelector('.swiper-container'), {
      slidesPerView: 1,
      autoplay: {
        delay: 5000
      },
      spaceBetween: 0,
      watchOverflow: true,
      pagination: {
        el: '.mtt-cover-slider__pagination',
        type: 'bullets',
        clickable: true
      },
      observer: true,
      observeParents: true
    })
  }
}
